'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'explosion';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4e9';
var svgPathData = 'M312 8l0-24-48 0 0 96 48 0 0-72zM24 464l-24 0 0 48 576 0 0-48-186.8 0c-10.8-45.9-52-80-101.2-80s-90.4 34.1-101.2 80L24 464zm213.4 0c9-18.9 28.3-32 50.6-32s41.6 13.1 50.6 32l-101.2 0zM32 336c21.3 34.7 37.7 61.3 49.2 80l56.4 0-19.7-32 63.7 0c-4.1-37.1-7.7-69.5-10.8-97.1 13.7 8.8 40.7 26.2 81.1 52.2 12.1-41.3 24-81.7 35.7-121.4 4.3 15.1 16 56.1 35.1 122.8 39.3-47.2 76.9-92.3 112.7-135.2-25.1 87.8-42.1 147.3-51.1 178.7l73.7 0-19.7 32 56.4 0c11.5-18.7 27.9-45.3 49.2-80l-96 0c3.1-11 24.3-85 63.4-221.9L544 0C495.2 58.6 440.9 123.7 381.2 195.4L344 240c-10.6-37.2-21.3-74.5-32-112l-48 0c-19.2 65.3-32.6 110.7-40 136-65.5-42.1-66.6-42.8-112-72 11 98.9 11.8 106.6 16 144l-96 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faExplosion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;